// extracted by mini-css-extract-plugin
export default {"imageContainer":"Image_imageContainer__W5PYB","image":"Image_image__exMH5"};